const appConfig = {
  get companyId() {
    return localStorage.getItem("blindspro_company_id") || "";
  },
  get companyName() {
    return localStorage.getItem("blindspro_business_name") || "BlindsPro CRM";
  },
  get companyFullName() {
    return localStorage.getItem("blindspro_business_name") || "BlindsPro CRM";
  },
  get companyShort() {
    const name = localStorage.getItem("blindspro_business_name");
    return name ? name.toUpperCase() : "BLINDSPRO CRM";
  },
  appVersion: '78',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  locale: "en-CA",
  province: "BC",
  currency: "CAD",
  currencySymbol: "$",
  vercelUrl: "blindsprocrm.com",
  industry: "window-blinds",
  productLabel: "window blinds installation",
  measurementUnit: "sq ft",
  get csvPrefix() {
    return localStorage.getItem("blindspro_company_id") || "blindspro";
  },
  measurementPrefix: "measurements",
  mapSearchQuery: "window blinds installation",
  get reminderSignature() {
    return localStorage.getItem("blindspro_business_name") || "BlindsPro CRM";
  },
  stripePublishableKey: "pk_live_51TZmL7Qd2egXy2XpZaIQBV4rSfftRoAnYXmisXGZGJJEAL889JFP63wXSr5ZJvUFscOVpVe8ndUjaxvIupGqeN4300KQz5rjxR",
};

export default appConfig;
